var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMyProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24,12.001C23.998,18.595,18.604,23.99,12.006,24 C5.41,24.008-0.022,18.572,0,11.982C0.022,5.377,5.423-0.012,12.01,0C18.61,0.012,24.002,5.409,24,12.001z M11.998,1.026 C5.928,1.028,1.025,5.933,1.026,12.001c0.001,6.068,4.909,10.973,10.976,10.973c6.069-0.002,10.975-4.91,10.973-10.977 C22.972,5.927,18.066,1.023,11.998,1.026z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.962,16.581c0.601-0.767,1.194-1.5,1.758-2.255 c0.212-0.283,0.454-0.381,0.796-0.362c2.474,0.139,4.494,1.667,5.231,3.96c0.064,0.199,0.045,0.338-0.096,0.5 c-2.162,2.469-4.874,3.697-8.161,3.545c-2.848-0.133-5.193-1.344-7.083-3.467c-0.184-0.207-0.228-0.387-0.135-0.661 c0.758-2.249,2.856-3.811,5.23-3.876c0.271-0.008,0.47,0.081,0.638,0.303c0.509,0.667,1.033,1.323,1.552,1.983 C11.777,16.355,11.862,16.457,11.962,16.581z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.506,9.052c0.005-2.483,2.003-4.488,4.484-4.5 c2.484-0.011,4.506,2.016,4.503,4.512c-0.004,2.514-2.012,4.497-4.546,4.49C9.497,13.547,7.501,11.523,7.506,9.052z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyProfile);
export default __webpack_public_path__ + "static/media/my-profile.3e25ca62e6f1be869c2aef31db06ba2d.svg";
export { ForwardRef as ReactComponent };